import type { CleanScheduleStatus } from '@prisma/client'

export const CLEAN_SCHEDULE_STATUS_MAPPING = {
  CREATED: '作成済',
  REQUESTED: '依頼中',
  REAPPROVAL: '再承認待ち',
  APPROVED: '承認済',
  STARTED: '清掃中',
  COMPLETED: '清掃完了',
  CANCELED: 'キャンセル済',
  CANCELED_AFTER_CHECKIN: 'チェックイン後キャンセル'
} as const satisfies Record<CleanScheduleStatus, string>

export const CLEAN_SCHEDULE_STATUS_MAPPING_REVERSED = Object.fromEntries(
  Object.entries(CLEAN_SCHEDULE_STATUS_MAPPING).map(([key, value]) => [value, key])
) as Record<string, CleanScheduleStatus>

// <Badge variant="red">再承認待ち</Badge>
export const CLEAN_SCHEDULE_STATUS_COLOR_MAPPING = {
  CREATED: 'secondary',
  REQUESTED: 'orange',
  REAPPROVAL: 'red',
  APPROVED: 'default',
  STARTED: 'teal',
  COMPLETED: 'purple',
  CANCELED: 'gray',
  CANCELED_AFTER_CHECKIN: 'yellow'
} as const satisfies Record<CleanScheduleStatus, string>
